import * as React from 'react';
import {
    FMIcon,
    FMList,
    FMListItem,
    FMListItemText,
} from 'atoms';
import {
    DevicesInfo,
    DeviceInfo,
} from 'features/FMDevicesInfo';

interface Props {
    devicesInfo: DevicesInfo;
    selectedDeviceName: string;
    onItemClick?: (data: DeviceInfo) => void;
}

const DevicesListPane = (props: Props) => {
    if (props.devicesInfo === null) {
        return <div />;
    }

    return (
        <FMList>
            {
                props.devicesInfo.groups.map(group =>
                    <React.Fragment key={group.name}>
                        <FMListItem>
                            <FMListItemText>{group.name}</FMListItemText>
                        </FMListItem>
                        {
                            group.devices.map(device =>
                                <FMListItem
                                    key={device.name}
                                    button={true}
                                    onClick={() => props.onItemClick(device)}
                                >
                                    <FMIcon type="empty" />
                                    <FMListItemText>{device.name}</FMListItemText>
                                </FMListItem>
                            )
                        }
                    </React.Fragment>
                )
            }
        </FMList>
    );
};

export default DevicesListPane;
